import React from "react";
import * as Components from "us.common/components";
import { useTranslation } from "react-i18next";
import { CONACTPERSONINFOCOLUMNS } from "us.collection.admin/components/CreditorApproval/Constants";
import { getContactPersonInfoTableColumns } from "us.collection.admin/components/CreditorApproval/Functions";

export type ContactPersonsInfoTableProps = {
  tableData: Array<any>;
};
const ContactPersonsInfoTable: React.FC<ContactPersonsInfoTableProps> = (
  props
) => {
  const { tableData } = props;
  const { $TableTree } = Components;
  const { t } = useTranslation();

  return (
    <$TableTree
      rowKey={(record: any) => record.requestId}
      data={tableData}
      size="small"
      filterOnType
      bordered
      className="mt-3"
      onSort={(sortData, dataSource) => {
        return sortData(dataSource);
      }}
      onFilter={(searchData, dataSource) => {
        return searchData(dataSource);
      }}
      pagination={false}
      columns={getContactPersonInfoTableColumns(
        CONACTPERSONINFOCOLUMNS,
        tableData
      )}
      data-testid="contact-person-info-table"
      locale={{
        filterConfirm: t("COMMON.OK"),
        filterReset: t("COMMON.RESET"),
      }}
      resetOnSourceChange={true}
      scroll={{ x: 1300, y: "calc(100vh - 195px)" }}
      style={{ marginLeft: 0, paddingLeft: 0 }}
      firstColSkipFilterProps={-1}
    />
  );
};

export default ContactPersonsInfoTable;
